<template>
  <!-- class="gw_btn_hover_back" -->
  <div
    :class="{ 'no-events': !hasEdit }"
    style="
      --btn-back-inset: 0 auto auto -0.25rem;
      --btn-back-width: calc(100% + 0.5rem);
      max-width: 100%;
    "
  >
    <div
      v-if="hasEdit && !tags.length"
      class="clr-grey no-events text-nowrap"
      v-html="tagsPlaceholder || $t('messages.assign_tags')"
    />
    <div
      v-else
      class="d-flex no-scroll-track"
      style="gap: 2px; min-width: 0; overflow-x: auto; overflow-y: hidden"
    >
      <div
        v-for="tag in tags"
        :key="tag.id"
        class="gw_btn gw_btn_tag no-events drilltagrow_list_tag tagdrill my-auto"
        :style="`--clr-back:${tag.color_hex}; min-width:3rem`"
      >
        <div
          class="truncate no-events"
          :title="tag.name"
          style="max-width: 22rem"
        >
          {{ tag.name }}
        </div>
      </div>

      <div
        v-if="hasEdit && hasPlus"
        class="ml-2 my-auto clr-grey mdi mdi-plus"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsTableCellList',
  props: {
    tags: { type: Array, default: () => [] },
    hasEdit: { type: Boolean, default: true },
    hasPlus: { type: Boolean, default: true },
    tagsPlaceholder: { default: '' },
  },
  data() {
    return {}
  },
}
</script>
